import { useTranslation } from 'react-i18next';
import type { Locale } from '../i18n';

export type { Locale };

// `es` intentionally omitted: the locale is frozen as of Phase 1 (PR-A,
// 2026-04-20). The file still exists on disk so it can be re-enabled in
// a future change without key loss. See `frontend/src/i18n/README.md`.
export const SUPPORTED_LOCALES: { code: Locale; label: string }[] = [
  { code: 'en', label: 'EN' },
  { code: 'zh', label: '中文' },
];

export function useLocale() {
  const { i18n } = useTranslation();
  const locale = (i18n.language as Locale) || 'en';

  // localStorage + <html lang> sync handled by i18n.on('languageChanged') in i18n/index.ts
  const setLocale = (l: Locale) => {
    i18n.changeLanguage(l);
  };

  return { locale, setLocale };
}
